export default __webpack_public_path__ + "10361875fc67ed94f6912c74efac8c5d.woff2";